import WithModal from "@components/HOC/withModals";
import { BtnStateE } from "@components/Pages/Clients/useClientsControl";
import Button from "@components/global/new/Button/Button";
import { MODALS_ENUM } from "@constants/Modals";
import styles from "./MoreClientModal.module.scss";
import { useMoreClientModalControl } from "./useMoreClientModalControl";

function MoreClientModal() {
  const control = useMoreClientModalControl();

  const myData = [
    11000, 12000, 10000, 10500, 12600, 11000, 12000, 10000, 10500, 12600, 11000,
    12000, 10000, 10500, 12600, 11000, 12000, 10000, 10500, 12600, 10500, 12600,
    9230, 12798, 10000, 11500, 16600,
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.more}>
        <div className={styles.details}>
          <div className={styles.btns_wrapper}>
            <Button
              grey
              active={control.isHashState}
              onClick={() => control.setChartState(BtnStateE.HASH)}
            >
              Recent Hashrate
            </Button>
            <Button
              grey
              active={!control.isHashState}
              onClick={() => control.setChartState(BtnStateE.TIME)}
            >
              State changes in time
            </Button>
          </div>

          <div className={styles.chart_wrapper}>
            {/* {control.isHashState && <SettingsBtns />} */}

            {/* <Charts data={myData} bubble={!control.isHashState} /> */}

            <div className={styles.status}>
              <div className={styles.status_row}>
                {/* <Status ok />
                <Status low />
                <Status off /> */}
              </div>
              <div className={styles.status_row}>
                <span>A01-371</span>
                <span>A01-3898</span>
                <span>A01-3123</span>
              </div>
              <div className={styles.status_row}>
                <span>A01-371</span>
                <span>A01-3898</span>
                <span>A01-3123</span>
              </div>
              <div className={styles.status_row}>
                <span>A01-371</span>
                <span>A01-3898</span>
                <span>A01-3123</span>
              </div>
              <div className={styles.status_row}>
                <span>A01-371</span>
                <span>A01-3898</span>
                <span>A01-3123</span>
              </div>
              <div className={styles.status_row}>
                <span>A01-371</span>
                <span>A01-3898</span>
                <span>A01-3123</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WithModal(MODALS_ENUM.MORE_CLIENT_MODAL, MoreClientModal);
